import React from 'react';
import { MessageContentWrapper } from './MessageContentWrapper';

interface Link {
    title: string;
    url: string;
    description?: string;
}

export const LinksDisplay = ({ links }: { links: Link[] }) => {
    return (
        <MessageContentWrapper>
            <div className='caption-1-bold text-gray mb-3'>Helpful Links:</div>
            <div className='space-y-2'>
                {links.map((link, index) => (
                    <div key={index} className='bg-brand-subtle border-subtle rounded-lg border p-3 shadow-sm'>
                        <a
                            href={link.url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='caption-1-bold text-brand-main hover:text-brand-dark mb-1 block'
                        >
                            {link.title}
                        </a>
                        {link.description && <p className='caption-2-regular text-gray'>{link.description}</p>}
                    </div>
                ))}
            </div>
        </MessageContentWrapper>
    );
};
